import { EMPTY_CONFIG_CODE } from "@/features/sub-families/resources/constants.ts";
import { EXTERNAL_POWER } from "@/resources/smart-number.ts";
import { type Nullable, SmartNumberDescriptor, type SmartNumberDescriptorKey } from "@/types";
import type { ProductPropertyKey, PropertyConfigCode, SmartNumberDescription, SmartNumberMapping } from "../types";

export const getSmartNumberDescriptorByProductProperty = (
    productProperty: ProductPropertyKey,
): Nullable<SmartNumberDescriptorKey> => {
    switch (productProperty) {
        case "beam_angle":
            return SmartNumberDescriptor.BeamAngle;

        case "cct":
            return SmartNumberDescriptor.CCT;

        case "cri":
            return SmartNumberDescriptor.CRI;

        case "ledchip":
            return SmartNumberDescriptor.LEDChip;

        case "light_distributor":
            return SmartNumberDescriptor.LightDistributor;

        case "dimension":
            return SmartNumberDescriptor.Dimension;

        case "light_acc":
            return SmartNumberDescriptor.Accessory;

        case "ceiling_meta_data":
            return SmartNumberDescriptor.MountingKit;

        default:
            return null;
    }
};

export const getConfigCodeByProductProperty = (
    productProperty: ProductPropertyKey,
    descriptor: SmartNumberDescriptorKey,
    smartNumberMapping: SmartNumberMapping,
    smartNumberDescription: SmartNumberDescription,
) => {
    const configCode = smartNumberMapping[descriptor];

    if (productProperty === "power_supply") {
        const isExternalPowerSelected = smartNumberMapping[SmartNumberDescriptor.DimType] === EXTERNAL_POWER;

        // TODO: Revalidate when data is present
        // When external power is selected, display so -> I think this is how it's done?
        if (isExternalPowerSelected) return EXTERNAL_POWER;
    }

    return getValidSelectedConfigCode(configCode, descriptor, smartNumberDescription);
};

export const getValidSelectedConfigCode = (
    configCode: Nullable<PropertyConfigCode>,
    descriptor: SmartNumberDescriptorKey,
    description: SmartNumberDescription,
) => {
    if (configCode !== null) return configCode;

    return getEmptyConfigCode(descriptor, description);
};

export const getEmptyConfigCode = (
    descriptor: SmartNumberDescriptorKey,
    description: SmartNumberDescription,
): Nullable<PropertyConfigCode> => {
    const descriptorDefinition = description.find(({ CharacteristicName }) => CharacteristicName === descriptor);
    if (!descriptorDefinition) return null;

    const padding = parseInt(descriptorDefinition.CharacteristicLength);
    if (Number.isNaN(padding)) return null;

    return EMPTY_CONFIG_CODE.padStart(padding, EMPTY_CONFIG_CODE) as PropertyConfigCode;
};
